module.exports = __webpack_public_path__ + "media/application/images/2018/star-green-966a2808d8cb9a722c0f05527ccb0b06.svg";